import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';
import queryString from 'query-string';

import { Button } from 'redpoints-front-components/index';
import { createContextFromLocalStore } from 'redpoints-front-common/authentication';
import { historyHelper, routeBuilder } from 'redpoints-front-common/helpers';

import {
  allIncidentsClearData,
  allIncidentsFetchData,
  allIncidentsFiltersClearFilters,
} from '../../../actions/allIncidentsActions';
import {
  getAllIncidentsApplyIsDisabled,
  getAllIncidentsClearIsDisabled,
  getAllIncidentsFilters,
  getAllIncidentsFiltersLevelStatusData,
} from '../../../reducers/reporting/allIncidents';
import { REPORT_TYPE } from './AllIncidents';
import { DEFAULT_CONTEXT_INFO, ROUTE_PATHS } from '../../../config/constants';
import { translate } from '../../../helpers/languageHelper';

const buildQueryParameters = filters => {
  const resp = { ...filters };
  return pickBy(resp, value => value !== null);
};

const historyPush = (filters, reportType) => {
  const context = createContextFromLocalStore({
    context: DEFAULT_CONTEXT_INFO,
  });

  const incidentRoute =
    reportType === REPORT_TYPE.INTERNAL
      ? ROUTE_PATHS.REPORTING_ALL_INCIDENTS
      : ROUTE_PATHS.REPORTING_ALL_INCIDENTS_CUSTOMER;

  const queryParams = !isEmpty(filters)
    ? `?${queryString.stringify(buildQueryParameters(filters))}`
    : '';

  historyHelper.push(routeBuilder(context, `${incidentRoute}${queryParams}`));
};

const AllIncidentsFiltersActions = ({
  allIncidentsClearData,
  allIncidentsFetchData,
  allIncidentsFiltersClearFilters,
  filters,
  incidentLevelStatusData,
  isApplyDisabled,
  isClearDisabled,
  reportType,
}) => {
  const applyFilters = useCallback(() => {
    historyPush(filters, reportType);
    allIncidentsFetchData({ filters, incidentLevelStatusData });
  }, [allIncidentsFetchData, filters, incidentLevelStatusData, reportType]);

  const clearFilters = useCallback(() => {
    historyPush({}, reportType);
    allIncidentsFiltersClearFilters();
    allIncidentsClearData();
  }, [allIncidentsFiltersClearFilters, allIncidentsClearData, reportType]);

  return (
    <>
      <Button
        aria-label="apply-btn"
        className="ant-btn-sm"
        type="primary"
        onClick={applyFilters}
        disabled={isApplyDisabled}
      >
        {translate('actions.apply')}
      </Button>
      <Button
        aria-label="clear-btn"
        className="ant-btn-sm"
        type="secondary"
        onClick={clearFilters}
        disabled={isClearDisabled}
      >
        {translate('actions.clear')}
      </Button>
    </>
  );
};

const mapStateToProps = state => ({
  incidentLevelStatusData: getAllIncidentsFiltersLevelStatusData(state),
  filters: getAllIncidentsFilters(state),
  isApplyDisabled: getAllIncidentsApplyIsDisabled(state),
  isClearDisabled: getAllIncidentsClearIsDisabled(state),
});

export default connect(mapStateToProps, {
  allIncidentsClearData,
  allIncidentsFetchData,
  allIncidentsFiltersClearFilters,
})(AllIncidentsFiltersActions);
